export const authData = () => {
  const isClient = typeof window !== 'undefined'
  const origin = isClient ? window.location.origin : ''
  const hostname = isClient ? window.location.hostname : ''

  return {
    auth: {
      authUrl: process.env.NEXT_PUBLIC_AUTH_URL,
      clientId: process.env.NEXT_PUBLIC_CLIENT_ID,
      redirectUri:
        hostname === 'localhost' ? 'https://test.payment.ewt.mts.ru/cyber/callback' : `${origin}/cyber/callback`,
      scope: 'openid sub profile sso',
      service: 'bank',
      responseType: 'code',
      theme: 'dark',
      prompt: 'login',
      realm: 'users',
    },
    sso: {
      ssoUrl: `${process.env.NEXT_PUBLIC_SSO_URL}/token`,
      redirectSsoUri:
        hostname === 'localhost' ? 'https://test.payment.ewt.mts.ru/cyber/callback' : `${origin}/cyber/callback`,
      grantType: 'mts_auth_code',
    },
  }
}
